import React from 'react';
interface Props {
  status: 'connected' | 'disconnected';
}
export const ConnectionStatus = ({
  status
}: Props) => {
  const styles = {
    connected: {
      container: 'bg-status-success/10 border-status-success/30 text-status-success',
      dot: 'bg-status-success animate-pulse'
    },
    disconnected: {
      container: 'bg-status-error/10 border-status-error/30 text-status-error',
      dot: 'bg-status-error'
    }
  };
  return <span className={`
        inline-flex items-center gap-1.5 px-2 sm:px-2.5 py-1 min-h-[24px] sm:min-h-[28px]
        border rounded-none text-[10px] sm:text-xs font-mono uppercase tracking-wider
        ${styles[status].container}
      `} data-id="element-674">
      <span className={`
          w-1.5 h-1.5 rounded-none shrink-0
          ${styles[status].dot}
        `} data-id="element-675" />
      <span className="line-clamp-1" data-id="element-676">
        {status === 'connected' ? 'Connected' : 'Disconnected'}
      </span>
    </span>;
};